import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ToPmDeterminationModalModule} from 'app/transition/modals/to-pm-determination-modal/to-pm-determination-modal.module';
import {BaseTransitionModalModule} from './base-transition-modal/base-transition-modal.module';
import {PmAppraisalModalModule} from './pm-appraisal-modal/pm-appraisal-modal.module';
import {PmDeterminationModalModule} from './pm-determination-modal/pm-determination-modal.module';
import {ProposerSubmitModalModule} from './proposer-submit-modal/proposer-submit-modal.module';
import {ReasonCodeSelectionModalModule} from './reason-code-selection-modal/reason-code-selection-modal.module';
import {RevertModalModule} from './revert-modal/revert-modal.module';
import {ReworkCompleteModalModule} from './rework-complete-modal/rework-complete-modal.module';
import {SpecialistAssignModalModule} from './specialist-assign-modal/specialist-assign-modal.module';
import {UserAssignModalModule} from './user-assign-modal/user-assign-modal.module';

@NgModule({
  imports: ModalsModule.IMPORTS
})
export class ModalsModule {
  public static readonly IMPORTS: any[] = [
    CommonModule,
    BaseTransitionModalModule,
    UserAssignModalModule,
    SpecialistAssignModalModule,
    PmAppraisalModalModule,
    ToPmDeterminationModalModule,
    PmDeterminationModalModule,
    RevertModalModule,
    ReworkCompleteModalModule,
    ReasonCodeSelectionModalModule,
    ProposerSubmitModalModule
  ];
}
